import {ApiClientService, EntityApiService} from '@dofleini/security';
import {authentication} from '@/settings';

class UserApiService extends EntityApiService {
  updateStatus = (params) => {
    return ApiClientService.post(this.getPath('/status'), params);
  };
  passwordReset = (params) => {
    return ApiClientService.post(this.getPath('/password-reset'), params);
  };
  searchIncidentsOwners = (params) => {
    return ApiClientService.post(this.getPath('/search-incidences-owners'), params);
  }
  getUserForAvatar = (userId) => {
    return ApiClientService.get(this.getPath(`/avatar/${userId}`), {});
  }
}

export default new UserApiService(`${authentication.path}/api/users`);
